<template>
  <div>
    <ba-header activeModule="Global User Actions" disable-menu="true"></ba-header>
    <div class="u-p4 main-content">
      <ba-insured-actions-component :companyId="null" headerCaption="Global User Actions"></ba-insured-actions-component>
    </div>
  </div>

</template>

<script>

import BaInsuredActions from '@/modules/insuredactions/insuredactions.component.vue'


export default {
  components: {
    'ba-insured-actions-component': BaInsuredActions,
  },
  name: 'ba-insured-actions',
  data () {
    return {
      companyId: this.$route.params.companyId,
    }
  },
}
</script>


